// Simula a latência de uma chamada de rede para que os estados de loading dos hooks
// já se comportem como vão se comportar com a API real (ver httpClient.ts).
export function mockDelay<T>(data: T, ms = 350): Promise<T> {
  return new Promise((resolve) => setTimeout(() => resolve(data), ms));
}
